var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAsTrader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32577 6.45007H18.6757C19.9668 6.45007 21.0132 7.49644 21.0132 8.78756V11.1251H2.98828V8.78756C2.98828 7.49644 4.03465 6.45007 5.32577 6.45007Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6757 22.25H5.32577C4.03465 22.25 2.98828 21.2037 2.98828 19.9125V13.1251H21.0132V19.9125C21.0132 21.2037 19.9668 22.25 18.6757 22.25Z",
    stroke: "url(#paint0_linear_10587_14088)",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 3.22493C12.0008 3.68551 12.0008 5.44992 12.0008 5.44992C12.0008 5.44992 10.5434 5.44992 9.77577 5.44992C8.54647 5.44992 7.55078 4.45424 7.55078 3.22493C7.55078 1.99562 8.54647 0.999939 9.77577 0.999939C11.0051 0.999939 12.0008 1.99562 12.0008 3.22493Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.22493C12 3.68551 12 5.44992 12 5.44992C12 5.44992 13.4574 5.44992 14.225 5.44992C15.4543 5.44992 16.45 4.45424 16.45 3.22493C16.45 1.99562 15.4543 0.999939 14.225 0.999939C12.9957 0.999939 12 1.99562 12 3.22493Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10587_14088",
    x1: 1.98828,
    y1: 17.6875,
    x2: 22.0132,
    y2: 17.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11AF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20DDA5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsTrader);
export default __webpack_public_path__ + "static/media/as_trader.fc22f62927e826e47a5c627ec34194f2.svg";
export { ForwardRef as ReactComponent };